import { SET_AKAMAI_LOC_ZIPCODE } from '../actionTypes/LocationActionTypes';

const setAkamaiGeoZipcode = () => ({
    type: SET_AKAMAI_LOC_ZIPCODE,
});

export default {
    setAkamaiGeoZipcode,
};
